module.exports = __webpack_public_path__ + "static/media/brk.79c86a86.svg";